var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSubscribers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1690",
    "data-name": "Group 1690",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M32.151,25.657v2.832H1V25.657ZM11.62,3a6.372,6.372,0,0,1,5.852,8.892l-1.107,2.659-.042.136a.855.855,0,0,0,.12.674.864.864,0,0,0,.718.382,4.247,4.247,0,0,1,4.147,3.272l.912,3.808H19.309l-.755-3.148a1.429,1.429,0,0,0-1.393-1.1,3.693,3.693,0,0,1-3.417-5.061l1.133-2.737a3.54,3.54,0,1,0-6.5,0V10.8L9.5,13.464a3.691,3.691,0,0,1-3.417,5.112,1.428,1.428,0,0,0-1.4,1.1l-.75,3.146H1.02l.912-3.808a4.247,4.247,0,0,1,4.147-3.272.86.86,0,0,0,.8-1.192L5.768,11.892A6.372,6.372,0,0,1,11.62,3Zm7.788.367a6.373,6.373,0,0,1,7.975,8.526l-1.107,2.659-.042.136a.852.852,0,0,0,.12.673.863.863,0,0,0,.716.384,4.247,4.247,0,0,1,4.149,3.272l.912,3.808H29.219l-.755-3.148a1.43,1.43,0,0,0-1.395-1.1,3.693,3.693,0,0,1-3.414-5.068l1.133-2.731A3.544,3.544,0,0,0,19.408,6.54Z",
    transform: "translate(-1 -3)",
    fill: "#ffffff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSubscribers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-subscribers.4eea32eb.svg";
export { ForwardRef as ReactComponent };